import { render, staticRenderFns } from "./marketingTab.vue?vue&type=template&id=17c24427&scoped=true&"
import script from "./marketingTab.vue?vue&type=script&lang=js&"
export * from "./marketingTab.vue?vue&type=script&lang=js&"
import style0 from "./marketingTab.vue?vue&type=style&index=0&id=17c24427&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c24427",
  null
  
)

export default component.exports